import type { SpacingValue } from '../../../common/sizing';
import { styled } from '../../../stitches.config';

const ChassisGapContainer = styled('div', {
  display: 'flex',
  height: '100%',
  position: 'relative',
});
ChassisGapContainer.displayName = 'ChassisGapContainer';

export type ChassisGapProps = {
  width: SpacingValue;
};

export function ChassisGap({ width }: ChassisGapProps) {
  return <ChassisGapContainer style={{ width }} />;
}
